import React from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import RecommendationOutcomeTracker from "./RecommendationOutcomeTracker";

export default function BusinessFeedbackPanel({ onOpenActionQueue }) {
  return (
    <Box>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} justifyContent="space-between" alignItems={{ xs: "stretch", md: "flex-start" }}>
          <Box>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: "wrap", mb: 0.5 }}>
              <Typography variant="h6" sx={{ fontWeight: 800 }}>
                Business Feedback
              </Typography>
              <Chip size="small" color="info" label="Outcome tracking" />
            </Stack>
            <Typography variant="body2" color="text.secondary">
              Review operator outcomes for AI recommendations and keep a business-readable feedback loop beside the Action Queue.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} justifyContent={{ xs: "flex-start", md: "flex-end" }} sx={{ flexWrap: "wrap" }}>
            <Button variant="outlined" onClick={onOpenActionQueue}>
              Open Action Queue
            </Button>
          </Stack>
        </Stack>
        <Alert severity="info" sx={{ mt: 2 }}>
          Recommendation outcomes are stored locally only and do not push price, quantity, listing, or campaign changes to eBay.
        </Alert>
      </Paper>

      <RecommendationOutcomeTracker onOpenActionQueue={onOpenActionQueue} />
    </Box>
  );
}
